
//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.Azure.Pipelines.Authorization.WebApi
// Microsoft.TeamFoundation.Build.Common
// Microsoft.TeamFoundation.Build2.Server
// Microsoft.TeamFoundation.Build2.WebApi
//----------------------------------------------------------


export module AgentTargetExecutionType {
    export const Normal = 0;
    export const VariableMultipliers = 1;
    export const MultipleAgents = 2;
}

export module ArtifactResourceTypes {
    /**
    * UNC or local folder path E.g. \\vscsstor\CIDrops\CloudU.Gated\140317.115955 or file://vscsstor/CIDrops/CloudU.Gated/140317.115955
    */
    export const FilePath = "FilePath";
    /**
    * Symbol store UNC path E.g. \\symbolstore
    */
    export const SymbolStore = "SymbolStore";
    /**
    * TF VC server folder path E.g. $/Dev1/Drops/CloudU.Gated/140317.115955
    */
    export const VersionControl = "VersionControl";
    /**
    * Build container reference E.g. #/2121/drop
    */
    export const Container = "Container";
    /**
    * Git ref E.g. refs/tags/MyCIDefinition.Buildable
    */
    export const GitRef = "GitRef";
    /**
    * TFVC label
    */
    export const TfvcLabel = "TfvcLabel";
    /**
    * Symbol store URL E.g. https://mseng.artifacts.visualstudio.com/...
    */
    export const SymbolRequest = "SymbolRequest";
    /**
    * Dedup Drop (old name fo PipelineArtifact) E.g. drop1
    */
    export const Drop = "Drop";
    /**
    * Dedup'ed pipeline artifact E.g. artifact1
    */
    export const PipelineArtifact = "PipelineArtifact";
}

export module Build2ResourceIds {
    export const Artifacts = "1db06c96-014e-44e1-ac91-90b2d4b3e984";
    export const Attachment = "af5122d3-3438-485e-a25a-2dbbfde84ee6";
    export const Attachments = "f2192269-89fa-4f94-baf6-8fb128c55159";
    export const BuildBadge = "21b3b9ce-fad5-4567-9ad0-80679794e003";
    export const BuildChangesBetweenBuilds = "f10f0ea5-18a1-43ec-a8fb-2042c7be9b43";
    export const BuildChanges = "54572c7b-bbd3-45d4-80dc-28be08941620";
    export const BuildDefinitionBadge = "de6a4df8-22cd-44ee-af2d-39f6aa7a4261";
    export const BuildDeployments = "f275be9a-556a-4ee9-b72f-f9c8370ccaee";
    export const BuildLogs = "35a80daf-7f30-45fc-86e8-6b813d9c90df";
    export const BuildProperties = "0a6312e9-0627-49b7-8083-7d74a64849c9";
    export const BuildReport = "45bcaa88-67e1-4042-a035-56d3b4a7d44c";
    export const BuildLeases = "3da19a6a-f088-45c4-83ce-2ad3a87be6c4";
    export const Builds = "0cd358e1-9217-4d94-8269-1c1ee6f93dcf";
    export const BuildTags = "6e6114b2-8161-44c8-8f6c-c5505782427f";
    export const BuildStages = "b8aac6c9-744b-46e1-88fc-3550969f9313";
    export const BuildWorkItemsBetweenBuilds = "52ba8915-5518-42e3-a4bb-b0182d159e2d";
    export const BuildWorkItems = "5a21f5d2-5642-47e4-a0bd-1356e6731bee";
    export const Controllers = "fcac1932-2ee1-437f-9b6f-7f696be858f6";
    export const DefinitionMetrics = "d973b939-0ce0-4fec-91d8-da3940fa1827";
    export const DefinitionProperties = "d9826ad7-2a68-46a9-a6e9-677698777895";
    export const DefinitionResources = "ea623316-1967-45eb-89ab-e9e6110cf2d6";
    export const DefinitionRevisions = "7c116775-52e5-453e-8c5d-914d9762d8c4";
    export const Definitions = "dbeaf647-6167-421a-bda9-c9327b25e2e6";
    export const Yaml = "7c3df3a1-7e51-4150-8cf7-540347f8697f";
    export const DefinitionTags = "cb894432-134a-4d31-a839-83beceaace4b";
    export const Folders = "a906531b-d2da-4f55-bda7-f3e676cc50d9";
    export const GeneralSettings = "c4aefd19-30ff-405b-80ad-aca021e7242a";
    export const InformationNodes = "9f094d42-b41c-4920-95aa-597581a79821";
    export const InputValuesQuery = "2182a7f0-b363-4b2d-b89e-ed0a0b721e95";
    export const LatestBuildLocationId = "54481611-01f4-47f3-998f-160da0f0c229";
    export const Metrics = "104ad424-b758-4699-97b7-7e7da427f9c2";
    export const Options = "591cb5a4-2d46-4f3a-a697-5cd42b6bd332";
    export const ProjectMetrics = "7433fae7-a6bc-41dc-a6e2-eef9005ce41a";
    export const ProjectAuthorizedResources = "398c85bc-81aa-4822-947c-a194a05f0fef";
    export const Queues = "09f2a4b8-08c9-4991-85c3-d698937568be";
    export const Retention = "dadb46e7-5851-4c72-820e-ae8abb82f59f";
    export const RetentionLease = "272051e4-9af1-45b5-ae22-8d960a5539d4";
    export const RetentionHistory = "1a9c48be-0ef5-4ec2-b94f-f053bdd2d3bf";
    export const Settings = "aa8c1c9c-ef8b-474a-b8c4-785c7b191d0d";
    export const SourceProviderBranchesLocationId = "e05d4403-9b81-4244-8763-20fde28d1976";
    export const SourceProviderFileContentsLocationId = "29d12225-b1d9-425f-b668-6c594a981313";
    export const SourceProviderPathContentsLocationId = "7944d6fb-df01-4709-920a-7a189aa34037";
    export const SourceProviderPullRequestsLocationId = "d8763ec7-9ff0-4fb4-b2b2-9d757906ff14";
    export const SourceProviderRepositoriesLocationId = "d44d1680-f978-4834-9b93-8c6e132329c9";
    export const SourceProviderRestoreWebhooksLocationId = "793bceb8-9736-4030-bd2f-fb3ce6d6b478";
    export const SourceProviders = "3ce81729-954f-423d-a581-9fea01d25186";
    export const SourceProviderWebhooksLocationId = "8f20ff82-9498-4812-9f6e-9c01bdc50e99";
    export const Sources = "56efdcdc-cf90-4028-9d2f-d41000682202";
    export const StatusBadgeLocationId = "07acfdce-4757-4439-b422-ddd13a2fcc10";
    export const Tags = "d84ac5c6-edc7-43d5-adc9-1b34be5dea09";
    export const Templates = "e884571e-7f92-4d6a-9274-3f5649900835";
    export const Timelines = "8baac422-4c6e-4de5-8532-db96d92acffa";
    export const Usage = "3813d06c-9e36-4ea1-aac3-61a485d60e3d";
    export const AreaId = "5D6898BB-45EC-463F-95F9-54D49C71752E";
    export const AreaName = "build";
    export const ArtifactsResource = "artifacts";
    export const AttachmentLocation = "AF5122D3-3438-485E-A25A-2DBBFDE84EE6";
    export const AttachmentsLocation = "F2192269-89FA-4F94-BAF6-8FB128C55159";
    export const AttachmentsResource = "attachments";
    export const BuildBadgeResource = "buildbadge";
    export const BuildChangesLocationId = "54572C7B-BBD3-45D4-80DC-28BE08941620";
    export const BuildChangesResource = "changes";
    export const BuildDefinitionBadgeResource = "badge";
    export const BuildDeploymentsResource = "deployments";
    export const BuildLogsResource = "logs";
    export const BuildPropertiesLocationString = "0A6312E9-0627-49B7-8083-7D74A64849C9";
    export const BuildReportResource = "report";
    export const BuildLeasesLocationString = "3DA19A6A-F088-45C4-83CE-2AD3A87BE6C4";
    export const BuildLeasesResource = "buildleases";
    export const BuildsResource = "builds";
    export const BuildTagsLocationIdString = "6E6114B2-8161-44C8-8F6C-C5505782427F";
    export const BuildTagsResource = "tags";
    export const BuildStagesResource = "stages";
    export const BuildWorkItemsLocationId = "5A21F5D2-5642-47E4-A0BD-1356E6731BEE";
    export const BuildWorkItemsResource = "workitems";
    export const ControllersLocationString = "{FCAC1932-2EE1-437F-9B6F-7F696BE858F6}";
    export const ControllersResource = "Controllers";
    export const DefinitionMetricsLocationString = "D973B939-0CE0-4FEC-91D8-DA3940FA1827";
    export const DefinitionMetricsResource = "metrics";
    export const DefinitionPropertiesLocationString = "D9826AD7-2A68-46A9-A6E9-677698777895";
    export const DefinitionResourcesResource = "resources";
    export const DefinitionRevisionsResource = "revisions";
    export const DefinitionsResource = "definitions";
    export const YamlResource = "yaml";
    export const DefinitionTagsLocationIdString = "CB894432-134A-4D31-A839-83BECEAACE4B";
    export const FoldersResource = "folders";
    export const GeneralSettingsResource = "generalSettings";
    export const InputValuesQueryResource = "InputValuesQuery";
    export const LatestBuildResource = "latest";
    export const MetricsResource = "Metrics";
    export const OptionsResource = "options";
    export const ProjectMetricsLocationString = "7433FAE7-A6BC-41DC-A6E2-EEF9005CE41A";
    export const ProjectAuthorizedResourcesResource = "authorizedresources";
    export const PropertiesResource = "properties";
    export const QueuesResource = "queues";
    export const RetentionResource = "retention";
    export const RetentionLeaseResource = "leases";
    export const RetentionHistoryResource = "history";
    export const SettingsResource = "settings";
    export const SourceProviderBranchesResource = "branches";
    export const SourceProviderBranchesLocationIdString = "E05D4403-9B81-4244-8763-20FDE28D1976";
    export const SourceProviderFileContentsResource = "fileContents";
    export const SourceProviderFileContentsLocationIdString = "29D12225-B1D9-425F-B668-6C594A981313";
    export const SourceProviderPathContentsResource = "pathContents";
    export const SourceProviderPathContentsLocationIdString = "7944D6FB-DF01-4709-920A-7A189AA34037";
    export const SourceProviderPullRequestsResource = "pullRequests";
    export const SourceProviderPullRequestsLocationIdString = "D8763EC7-9FF0-4FB4-B2B2-9D757906FF14";
    export const SourceProviderRepositoriesResource = "repositories";
    export const SourceProviderRepositoriesLocationIdString = "D44D1680-F978-4834-9B93-8C6E132329C9";
    export const SourceProviderRestoreWebhooksLocationIdString = "793BCEB8-9736-4030-BD2F-FB3CE6D6B478";
    export const SourceProvidersResource = "sourceProviders";
    export const SourceProvidersLocationIdString = "3CE81729-954F-423D-A581-9FEA01D25186";
    export const SourceProviderWebhooksResource = "webhooks";
    export const SourceProviderWebhooksLocationIdString = "8F20FF82-9498-4812-9F6E-9C01BDC50E99";
    export const SourcesLocationId = "56EFDCDC-CF90-4028-9D2F-D41000682202";
    export const SourcesResource = "sources";
    export const StatusBadgeLocationIdString = "07ACFDCE-4757-4439-B422-DDD13A2FCC10";
    export const StatusBadgeResource = "status";
    export const TagsLocationIdString = "D84AC5C6-EDC7-43D5-ADC9-1B34BE5DEA09";
    export const TemplatesResource = "templates";
    export const TimelinesResource = "Timeline";
    export const UsageResource = "ResourceUsage";
}

export module BuildArtifactConstants {
    export const Drop = "drop";
    export const SourceLabel = "build.SourceLabel";
}

export module BuildConstants {
    export const BuildOptionAdditionalFieldsName = "additionalFields";
}

export module BuildCustomerIntelligenceInfo {
    export const Area = "Build";
}

export module BuildEvents {
    export const ArtifactAdded = "artifactAdded";
    export const BuildUpdated = "buildUpdated";
    export const ChangesCalculated = "changesCalculated";
    export const ConsoleLinesReceived = "consoleLinesReceived";
    export const StagesUpdated = "stagesUpdated";
    export const TagsAdded = "tagsAdded";
    export const TimelineRecordsUpdated = "timelineRecordsUpdated";
}

export module BuildOrchestrationType {
    export const Build = 1;
    export const Cleanup = 2;
}

export module BuildPermissions {
    export const ViewBuilds = 1;
    export const EditBuildQuality = 2;
    export const RetainIndefinitely = 4;
    export const DeleteBuilds = 8;
    export const ManageBuildQualities = 16;
    export const DestroyBuilds = 32;
    export const UpdateBuildInformation = 64;
    export const QueueBuilds = 128;
    export const ManageBuildQueue = 256;
    export const StopBuilds = 512;
    export const ViewBuildDefinition = 1024;
    export const EditBuildDefinition = 2048;
    export const DeleteBuildDefinition = 4096;
    export const OverrideBuildCheckInValidation = 8192;
    export const AdministerBuildPermissions = 16384;
    export const AllPermissions = 32767;
}

export module BuildSecurity {
    export const BuildNamespaceId = "33344d9c-fc72-4d6f-aba5-fa317101a7e9";
}

export module BuildTemplateCategories {
    export const All = "All";
    export const Build = "Build";
    export const Utility = "Utility";
    export const Test = "Test";
    export const Package = "Package";
    export const Deploy = "Deploy";
    export const Tool = "Tool";
    export const Custom = "Custom";
    export const AllCategories = ["All", "Build", "Utility", "Test", "Package", "Deploy", "Tool", "Custom"];
}

export module BuildVariables {
    export const CollectionId = "system.collectionId";
    export const DefinitionId = "system.definitionId";
    export const HostType = "system.hosttype";
    export const IsFork = "system.pullRequest.isFork";
    export const ForkSecretsRemoved = "system.pullRequest.forkSecretsRemoved";
    export const PullRequestId = "system.pullRequest.pullRequestId";
    export const PullRequestNumber = "system.pullRequest.pullRequestNumber";
    export const PullRequestIterationId = "system.pullRequest.pullRequestIteration";
    export const PullRequestSourceBranch = "system.pullRequest.sourceBranch";
    export const PullRequestTargetBranch = "system.pullRequest.targetBranch";
    export const PullRequestTargetBranchName = "system.pullRequest.targetBranchName";
    export const PullRequestSourceRepositoryUri = "system.pullRequest.sourceRepositoryUri";
    export const PullRequestSourceCommitId = "system.pullRequest.sourceCommitId";
    export const PullRequestMergedAt = "system.pullRequest.mergedAt";
    export const System = "system";
    export const TeamProject = "system.teamProject";
    export const TeamProjectId = "system.teamProjectId";
    export const IsTriggeringRepository = "system.istriggeringrepository";
    export const SystemDebug = "system.debug";
    export const AgentDiagnostic = "agent.diagnostic";
    export const BuildId = "build.buildId";
    export const BuildNumber = "build.buildNumber";
    export const BuildUri = "build.buildUri";
    export const ContainerId = "build.containerId";
    export const DefinitionName = "build.definitionName";
    export const DefinitionVersion = "build.definitionVersion";
    export const JobAuthorizeAs = "Job.AuthorizeAs";
    export const JobAuthorizeAsId = "Job.AuthorizeAsId";
    export const QueuedBy = "build.queuedBy";
    export const QueuedById = "build.queuedById";
    export const Reason = "build.reason";
    export const RepoUri = "build.repository.uri";
    export const RepositoryId = "build.repository.id";
    export const RepositoryName = "build.repository.name";
    export const RepositoryUri = "build.repository.uri";
    export const RequestedFor = "build.requestedFor";
    export const RequestedForEmail = "build.requestedForEmail";
    export const RequestedForId = "build.requestedForId";
    export const SourceBranch = "build.sourceBranch";
    export const SourceBranchName = "build.sourceBranchName";
    export const SourceTfvcShelveset = "build.sourceTfvcShelveset";
    export const SourceVersion = "build.sourceVersion";
    export const SourceVersionAuthor = "build.sourceVersionAuthor";
    export const SourceVersionMessage = "build.sourceVersionMessage";
    export const SyncSources = "build.syncSources";
}

export module DefinitionMetrics {
    export const SuccessfulBuilds = "SuccessfulBuilds";
    export const FailedBuilds = "FailedBuilds";
    export const PartiallySuccessfulBuilds = "PartiallySuccessfulBuilds";
    export const CanceledBuilds = "CanceledBuilds";
    export const TotalBuilds = "TotalBuilds";
    export const CurrentBuildsInQueue = "CurrentBuildsInQueue";
    export const CurrentBuildsInProgress = "CurrentBuildsInProgress";
}

export module Favorites {
    export const BuildDefinitionFavoriteId = "Microsoft.TeamFoundation.Build.Definition";
    export const GitRepositoryFavoriteId = "Microsoft.TeamFoundation.Git.Repository";
}

export module Links {
    export const Avatar = "avatar";
    export const Self = "self";
    export const Web = "web";
    export const Editor = "editor";
    export const Badge = "badge";
    export const Timeline = "timeline";
    export const Details = "details";
    export const SourceVersionDisplayUri = "sourceVersionDisplayUri";
}

export module MetricAggregationTypes {
    export const Hourly = "Hourly";
    export const Daily = "Daily";
}

export module PhaseTargetType {
    export const Agent = 1;
    export const Server = 2;
}

export module PipelinePermissionsResourceIds {
    export const AreaName = "pipelinePermissions";
    export const AreaId = "a81a0441-de52-4000-aa15-ff0e07bfbbaa";
    export const AuthorizationsLocationIdString = "b5b9a4a4-e6cd-4096-853c-ab7d8b0c4eb2";
    export const ProjectAuthorizedResourcesResource = "pipelinePermissions";
}

export module ProcessType {
    export const Designer = 1;
    export const Yaml = 2;
    export const Docker = 3;
    export const JustInTime = 4;
}

export module RepositoryProperties {
    export const AcceptUntrustedCertificates = "acceptUntrustedCerts";
    export const ApiUrl = "apiUrl";
    export const Archived = "archived";
    export const BranchesUrl = "branchesUrl";
    export const CheckoutNestedSubmodules = "checkoutNestedSubmodules";
    export const CleanOptions = "cleanOptions";
    export const CloneUrl = "cloneUrl";
    export const ConnectedServiceId = "connectedServiceId";
    export const DefaultBranch = "defaultBranch";
    export const ExternalId = "externalId";
    export const FetchDepth = "fetchDepth";
    export const FetchTags = "fetchTags";
    export const Fullname = "fullName";
    export const GitLfsSupport = "gitLfsSupport";
    export const HasAdminPermissions = "hasAdminPermissions";
    export const IsFork = "isFork";
    export const IsJustInTimeRepository = "isJustInTimeRepository";
    export const IsPrivate = "isPrivate";
    export const LabelSources = "labelSources";
    export const LabelSourcesFormat = "labelSourcesFormat";
    export const Languages = "languages";
    export const LastUpdated = "lastUpdated";
    export const ManageUrl = "manageUrl";
    export const NodeId = "nodeId";
    export const OwnerAvatarUrl = "ownerAvatarUrl";
    export const OwnerId = "ownerId";
    export const OwnerIsAUser = "ownerIsAUser";
    export const OrgName = "orgName";
    export const Password = "password"; // [SuppressMessage("Microsoft.Security", "CS001:SecretInline")]
    export const PrimaryLanguage = "primaryLanguage";
    export const RefsUrl = "refsUrl";
    export const ReportBuildStatus = "reportBuildStatus";
    export const SafeId = "safeId";
    export const SafeRepository = "safeRepository";
    export const ShortName = "shortName";
    export const SkipSyncSource = "skipSyncSource";
    export const SvnMapping = "svnMapping";
    export const TfvcMapping = "tfvcMapping";
    export const TokenType = "tokenType";
    export const Username = "username";
    export const HasCITrigger = "hasCITrigger";
    export const HasPRTrigger = "hasPRTrigger";
    export const SourceVersion = "sourceVersion";
}

export module RepositoryTypes {
    export const TfsVersionControl = "TfsVersionControl";
    export const TfsGit = "TfsGit";
    export const Git = "Git";
    export const GitHub = "GitHub";
    export const GitHubEnterprise = "GitHubEnterprise";
    export const Bitbucket = "Bitbucket";
    export const Svn = "Svn";
}

export module ServerTargetExecutionType {
    export const Normal = 0;
    export const VariableMultipliers = 1;
}

export module SettingsSourceType {
    export const Definition = 1;
    export const Process = 2;
}

